export default __webpack_public_path__ + "static/SRF 3200ACS15 - Fiche de spécifications et données techniques-4690f2169a2e2fb3786908045d81922a.pdf";